// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_logo_image-module__logoImage--nn85Q{margin-top:auto;margin-bottom:auto;background-image:url(/img/logo/logos_doctrine/logo_navbar.png);background-repeat:no-repeat;-webkit-background-size:100% 100%;-moz-background-size:100%;background-size:100%;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;background-position:0px;height:30px;width:32px;display:block}\n", ""]);
// Exports
exports.locals = {
	"logoImage": "header_logo_image-module__logoImage--nn85Q"
};
module.exports = exports;
